<template>
  <div class="study">
    <Header></Header>
    <div class="detail-wrappers">
      <div class="prodet-bg" :style="{height:windowHeight+'px'}">
        <div class="container" style="overflow: hidden;">
          <div class="por-box-location" ref="videoTop" data-key="0">
            <i class="el-icon-map-location"></i>
            <span>  <span>当前回放</span> {{info.title}}</span>
          </div>
          <div class="prodet-player clearfix">
            <div class="live-box-c">
              <div class="video-wrapper">
                <div >
                  <div id="player"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '../components/header.vue'
  import {
    getLiveDetail
  } from "../api/api";

  export default {
    name: 'Study',
    data() {
      return {
        id: 0,
        lid: 0,
        info: {},
        windowHeight: document.documentElement.clientHeight,
        vodPlayerJs: '//player.polyv.net/resp/vod-player/latest/player.js',
        vid: '',
        player: {},
      }
    },
    created() {
      const lid = this.$route.params.lid;
      this.lid = parseInt(lid);
      var token = window.localStorage.getItem('jwt_token')
      if (!token) {
        this.$router.push('/login')
      }
    },
    mounted() {
      this.getLiveDetail();
    },
    methods: {
      getLiveDetail(){
        var _this = this
        getLiveDetail({id:this.lid}).then(res =>{
          _this.info = res.data
          _this.vid = res.data.video_id
          _this.loadPlayerScript(_this.loadPlayer);
        })
      },

      loadPlayerScript(callback) {
        // if (!window.polyvPlayer) {
          const myScript = document.createElement('script');
          myScript.setAttribute('src', this.vodPlayerJs);
          myScript.onload = callback;
          document.body.appendChild(myScript);
        // } else {
        //   callback();
        // }
      },
      loadPlayer() {
        const polyvPlayer = window.polyvPlayer;
        this.player = polyvPlayer({
          wrap: '#player',
          width: 1200,
          height: 675,
          vid: this.vid,
          speed:[2, 1.75, 1.5, 1.25, 0.75,0.5],
        });
        // this.onReadyPlay()  //加载完
        // this.onPlayerStart()
        // this.onPlayerPlay()  //播放
        // this.onPlayerPause()  //暂停
        // this.errorx()        //错误
        // this.endedx()       //结束

        // this.player.HTML5.video.addEventListener('ratechange', this.palyRatechange);
      },


    },
    components: {
      Header,
    },
  }
</script>

<style>
  .study-list {
    margin: 0
  }

  .study-list+.study-list {
    border-top: 1px solid #ddd
  }

  .study-list dt {
    font-weight: 400;
    cursor: pointer;
    line-height: 1.2;
    padding: 20px 0
  }

  .study-list dt>span {
    font-weight: 700;
    font-size: 22px
  }

  .study-list dt>span>img {
    display: inline-block;
    margin-right: 16px;
    vertical-align: -.1em
  }

  .study-list dt>span>i {
    font-size: 24px;
    color: #999;
    transition: all .2s ease
  }

  .study-list dt>span>span {
    font-size: 1.6rem;
    color: #999;
    font-weight: 400;
    margin-top: 10px;
    display: inline-block
  }

  .study-list dt.active>span>i {
    transform: rotate(180deg)
  }

  .study-list dd {
    padding-bottom: 10px
  }

  .study-list dd div {
    padding: 20px 10px;
    line-height: 1.3;
    border-bottom: 1px dashed #ddd
  }

  .study-list dd div:last-child {
    border-bottom: none
  }

  .study-list dd div .icon {
    margin-top: 5px;
    margin-right: 20px
  }

  .study-list dd div>span {
    display: inline-block;
    vertical-align: top;
    font-size: 20px
  }

  .study-list dd div>span>span {
    font-size: 14px;
    color: #999;
    font-weight: 400;
    display: inline-block;
    margin-top: 10px;
    margin-right: 50px
  }

  .study-list dd div>p {
    margin-top: 1.6rem
  }

  .study-list dd div .text-color {
    color: #227efa
  }

  .study-wrap {
    padding: 0 10px
  }

  .study-wrap .item-dot {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    border: 1px solid #ddd;
    display: inline-flex;
    align-items: center;
    justify-content: center
  }

  .study-wrap .item-dot span {
    width: 7px;
    height: 7px;
    border-radius: 7px;
    background: #eee
  }

  .study-wrap .ivu-timeline-item-tail {
    border: 1px dashed #ddd
  }

  .study-list {
    margin: 0
  }

  .study-list+.study-list {
    border-top: 1px solid #ddd
  }

  .study-list dt {
    font-weight: 400;
    cursor: pointer;
    line-height: 1.2;
    padding: 20px 0
  }

  .study-list dt>span {
    font-weight: 700;
    font-size: 22px
  }

  .study-list dt>span>img {
    display: inline-block;
    margin-right: 16px;
    vertical-align: -.1em
  }

  .study-list dt>span>i {
    font-size: 24px;
    color: #999;
    transition: all .2s ease
  }

  .study-list dt>span>span {
    font-size: 1.6rem;
    color: #999;
    font-weight: 400;
    margin-top: 10px;
    display: inline-block
  }

  .study-list dt.active>span>i {
    transform: rotate(180deg)
  }

  .study-list dd {
    padding-bottom: 10px
  }

  .study-list dd div {
    padding: 20px 10px;
    line-height: 1.3;
    border-bottom: 1px dashed #ddd
  }

  .study-list dd div:last-child {
    border-bottom: none
  }

  .study-list dd div .icon {
    margin-top: 5px;
    margin-right: 20px
  }

  .study-list dd div>span {
    display: inline-block;
    vertical-align: top;
    font-size: 20px
  }

  .study-list dd div>span>span {
    font-size: 14px;
    color: #999;
    font-weight: 400;
    display: inline-block;
    margin-top: 10px;
    margin-right: 50px
  }

  .study-list dd div>p {
    margin-top: 1.6rem
  }

  .study-list dd div .text-color {
    color: #227efa
  }

  .simexam-wrapper {
    width: 100%;
    padding: 0 10px;
    margin-top: -10px
  }

  .simexam-wrapper .simexam-score-text {
    font-size: 16px;
    color: #666;
    padding-bottom: 20px
  }

  .simexam-wrapper .simexam-score-text .study-list .iconfont {
    color: #3ac2d9 !important;
    font-size: 24px
  }

  .simexam-wrapper .simexam-score {
    font-size: 40px;
    color: #227efa
  }

  .verify-title {
    font-size: 1.6rem;
    padding: 25px 10px 25px 10px;
    text-align: center
  }

  .verify-input {
    text-align: center
  }

  .verify-tips {
    color: red;
    font-size: 1.4rem;
    height: 20px;
    margin: 10px auto;
    text-align: center
  }

  .phone-no-tips {
    font-size: 1.6rem;
    text-align: center
  }

  .phone-title {
    text-align: center;
    margin: 20px auto
  }

  .phone-input {
    text-align: center
  }

  .study-list {
    margin: 0
  }

  .study-list+.study-list {
    border-top: 1px solid #ddd
  }

  .study-list dt {
    font-weight: 400;
    cursor: pointer;
    line-height: 1.2;
    padding: 20px 0
  }

  .study-list dt>span {
    font-weight: 700;
    font-size: 22px
  }

  .study-list dt>span>img {
    display: inline-block;
    margin-right: 16px;
    vertical-align: -.1em
  }

  .study-list dt>span>i {
    font-size: 24px;
    color: #999;
    transition: all .2s ease
  }

  .study-list dt>span>span {
    font-size: 1.6rem;
    color: #999;
    font-weight: 400;
    margin-top: 10px;
    display: inline-block
  }

  .study-list dt.active>span>i {
    transform: rotate(180deg)
  }

  .study-list dd {
    padding-bottom: 10px
  }

  .study-list dd div {
    padding: 20px 10px;
    line-height: 1.3;
    border-bottom: 1px dashed #ddd
  }

  .study-list dd div:last-child {
    border-bottom: none
  }

  .study-list dd div .icon {
    margin-top: 5px;
    margin-right: 20px
  }

  .study-list dd div>span {
    display: inline-block;
    vertical-align: top;
    font-size: 20px
  }

  .study-list dd div>span>span {
    font-size: 14px;
    color: #999;
    font-weight: 400;
    display: inline-block;
    margin-top: 10px;
    margin-right: 50px
  }

  .study-list dd div>p {
    margin-top: 1.6rem
  }

  .study-list dd div .text-color {
    color: #227efa
  }

  .review-wrapper {
    width: 100%;
    padding: 0 10px;
    margin-top: -10px;
    position: relative
  }

  .review-wrapper .review-nodata {
    text-align: center;
    padding: 30px 0
  }

  .review-wrapper .review-nodata img {
    display: inline-block;
    vertical-align: middle
  }

  .review-wrapper .review-buy .review-name {
    font-weight: 700;
    font-size: 1.6rem
  }

  .review-wrapper .review-buy .review-remark {
    padding-top: 10px
  }

  .review-wrapper .review-buy .review-num {
    margin-bottom: 2rem
  }

  .study-list {
    margin: 0
  }

  .study-list+.study-list {
    border-top: 1px solid #ddd
  }

  .study-list dt {
    font-weight: 400;
    cursor: pointer;
    line-height: 1.2;
    padding: 20px 0
  }

  .study-list dt>span {
    font-weight: 700;
    font-size: 22px
  }

  .study-list dt>span>img {
    display: inline-block;
    margin-right: 16px;
    vertical-align: -.1em
  }

  .study-list dt>span>i {
    font-size: 24px;
    color: #999;
    transition: all .2s ease
  }

  .study-list dt>span>span {
    font-size: 1.6rem;
    color: #999;
    font-weight: 400;
    margin-top: 10px;
    display: inline-block
  }

  .study-list dt.active>span>i {
    transform: rotate(180deg)
  }

  .study-list dd {
    padding-bottom: 10px
  }

  .study-list dd div {
    padding: 20px 10px;
    line-height: 1.3;
    border-bottom: 1px dashed #ddd
  }

  .study-list dd div:last-child {
    border-bottom: none
  }

  .study-list dd div .icon {
    margin-top: 5px;
    margin-right: 20px
  }

  .study-list dd div>span {
    display: inline-block;
    vertical-align: top;
    font-size: 20px
  }

  .study-list dd div>span>span {
    font-size: 14px;
    color: #999;
    font-weight: 400;
    display: inline-block;
    margin-top: 10px;
    margin-right: 50px
  }

  .study-list dd div>p {
    margin-top: 1.6rem
  }

  .study-list dd div .text-color {
    color: #227efa
  }

  .study-type {
    display: flex;
    width: 100%;
    margin-bottom: 20px;
    justify-content: center
  }

  .study-type li {
    text-align: center;
    font-weight: 700;
    color: #666;
    padding: 5px 20px 10px 20px;
    margin-right: 30px;
    cursor: pointer;
    font-size: 22px
  }

  .study-type li:after {
    content: " ";
    display: block;
    margin: 5px auto 0 auto;
    width: 90px;
    height: 5px;
    background: #fff
  }

  .study-type li.active,
  .study-type li:hover {
    color: #2595fd
  }

  .study-type li.active:after {
    background: linear-gradient(#27a4ff 21.43%, #227efa 95.7%)
  }

  .question-side-item {
    background-color: #fff;
    margin-bottom: 15px
  }

  .ask-header {
    font-size: 1.6rem;
    margin: 0 -20px;
    padding: 10px 20px
  }

  .ask-text {
    padding: 15px 0
  }

  .ask-text textarea {
    width: 100%;
    height: 180px;
    border-radius: 6px;
    background-color: #f5f5f5;
    outline: none;
    border: 1px solid #ececec;
    resize: none;
    font-size: 14px;
    padding: 10px 16px
  }

  .ask-action i {
    font-size: 32px;
    color: #999;
    cursor: pointer
  }

  .ask-action i:hover {
    color: #0095d3
  }

  .ask-image {
    padding: 10px 0
  }

  .ask-image span {
    float: left;
    position: relative;
    width: 73px;
    display: block;
    overflow: hidden;
    text-align: center;
    margin-right: 10px
  }

  .ask-image span img {
    width: 73px;
    height: 73px
  }

  .ask-image span>i {
    position: absolute;
    background-color: #fff;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: none;
    opacity: .4;
    z-index: 1
  }

  .ask-image span a {
    position: absolute;
    right: 3px;
    top: 3px;
    width: 15px;
    height: 15px;
    background: #f37b1d;
    color: #fff;
    display: none;
    z-index: 2;
    line-height: 1;
    border-radius: 3px
  }

  .ask-image span a>i {
    display: none
  }

  .ask-image span:hover a,
  .ask-image span:hover i {
    display: block
  }

  .question-wrap .question-empty {
    background-color: #fff;
    padding-bottom: 10px;
    color: #999;
    font-size: 16px;
    text-align: center
  }

  .question-wrap .question-empty img {
    margin: 0 auto
  }

  .question-subject {
    border: 2px solid #e6e6e6;
    padding: 0 30px;
    background-color: #fff
  }

  .question-statics {
    padding: 10px 0;
    background-color: #fff;
    border-bottom: 1px solid #ececec
  }

  .question-list {
    background-color: #fff;
    margin-bottom: 20px
  }

  .question-list .question-info {
    display: flex;
    align-items: center;
    width: 100%
  }

  .question-list .question-info .question-info-img {
    flex: 0 0 50px;
    width: 50px;
    height: 50px;
    display: block;
    margin-right: 20px
  }

  .question-list .question-info .question-info-user {
    flex: 1
  }

  .question-list .question-info .question-info-user .question-info-position {
    margin-top: 5px;
    color: #999
  }

  .question-list .question-info .question-info-time {
    flex: 0 0 150px;
    display: block;
    text-align: right;
    color: #999
  }

  .question-list .question-content {
    margin-top: 10px;
    margin-left: 70px
  }

  .question-list .question-content .question-title {
    font-size: 1.5rem
  }

  .question-list .question-content .question-image {
    margin-top: 10px
  }

  .question-list .question-content .question-image li {
    float: left;
    width: 74px;
    height: 70px
  }

  .question-list .question-content .question-image li img {
    width: 64px;
    height: 64px
  }

  .question-list .question-action {
    padding: 10px 0;
    font-size: 1.6rem;
    margin-left: 70px;
    text-align: left
  }

  .question-list .question-action>span {
    font-size: 12px;
    color: #999;
    margin-right: 40px
  }

  .question-list .question-action .question-action-like {
    margin-right: 40px;
    vertical-align: .12em;
    color: #999
  }

  .question-list .question-action .question-action-like.active {
    color: #0195d3
  }

  .question-list .question-action .question-action-like span {
    display: inline-block;
    vertical-align: -.2em;
    margin-left: 5px
  }

  .question-list .question-action .question-action-comment {
    color: #999
  }

  .question-list .question-action .question-action-comment span {
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px
  }

  .question-list .question-answer-wrapper {
    margin-top: 20px;
    padding-left: 70px;
    border-top: 1px solid #ddd
  }

  .question-list .question-answer {
    padding: 10px 0
  }

  .question-list .question-answer .question-answer-content {
    margin-top: 1rem
  }

  .question-list .question-answer .question-answer-content .question-answer-avatar {
    float: left;
    width: 30px;
    height: 30px;
    margin-right: 16px
  }

  .question-list .question-answer .question-answer-content .question-answer-name {
    color: #227efa;
    margin-right: 16px;
    display: inline-block;
    vertical-align: middle
  }

  .question-list .question-answer .question-answer-content .question-answer-show {
    display: inline-block;
    vertical-align: middle;
    word-break: break-all
  }

  .question-list .question-answer .question-answer-content p {
    line-height: 1.2;
    font-size: 14px
  }

  .question-list .question-answer .question-answer-content p:last-child {
    margin-top: 5px
  }

  .question-list .question-answer .question-answer-content p span.time {
    color: #999;
    margin-right: 2em
  }

  .question-list .question-answer .question-answer-content .replay-action {
    position: relative;
    color: #999
  }

  .question-list .question-answer .question-answer-content .replay-action.active,
  .question-list .question-answer .question-answer-content .replay-action:hover {
    color: #227efa
  }

  .question-list .question-answer .question-answer-content .replay-action.active:after {
    position: absolute;
    bottom: -11px;
    left: 50%;
    margin-left: -3px;
    content: " ";
    border: 6px solid transparent;
    border-bottom: 6px solid #ddd
  }

  .question-list .question-answer .question-answer-image {
    padding: 5px 0
  }

  .question-list .question-answer .question-answer-image li {
    float: left;
    width: 70px;
    height: 60px
  }

  .question-list .question-answer .question-answer-image li img {
    width: 60px;
    height: 60px
  }

  .question-list .question-answer-reply {
    padding: 10px 20px;
    margin: 20px 0 20px 46px;
    border: 1px solid #ddd
  }

  .question-list .question-answer-reply .question-answer-content {
    padding: 6px 0
  }

  .question-list .question-reply {
    margin-left: 70px
  }

  .question-list .comment-reply {
    margin-left: 46px;
    margin-top: 10px
  }

  .question-list .comment-reply input,
  .question-list .question-reply input {
    border: 1px solid #ddd;
    border-right: none;
    width: calc(100% - 90px);
    height: 40px;
    line-height: 40px;
    padding-left: 16px;
    outline: none;
    font-size: 12px;
    border-radius: 0
  }

  .question-list .comment-reply button,
  .question-list .question-reply button {
    width: 90px;
    height: 40px;
    line-height: 40px;
    border: none;
    background: linear-gradient(90deg, #27a3ff, #2380fb);
    color: #fff;
    outline: none;
    border-radius: 0
  }

  .question-image-view {
    width: 100%
  }

  .question-image-view img {
    max-width: 100%;
    margin: 0 auto
  }

  .question-title {
    font-size: 24px;
    font-weight: 700;
    padding: 30px 0;
    border-top: 1px solid #ddd
  }

  .question-title i {
    display: inline-block;
    vertical-align: -.26em;
    width: 4px;
    height: 28px;
    background: linear-gradient(#2da6fe, #2680fa);
    margin-right: 12px
  }

  .statistics-wrapper .statistics-box {
    margin-bottom: 20px
  }

  .statistics-wrapper .statistics-box .statistics-title {
    font-size: 24px;
    font-weight: 700;
    margin: 30px 0
  }

  .statistics-wrapper .statistics-box .statistics-title i {
    display: inline-block;
    vertical-align: -.26em;
    width: 4px;
    height: 28px;
    background: linear-gradient(#2da6fe, #2680fa);
    margin-right: 12px
  }

  .statistics-wrapper .statistics-box .statistics-body {
    display: flex;
    flex-wrap: wrap
  }

  .statistics-wrapper .statistics-box .statistics-body.video li {
    margin-right: 30px;
    background: url(../assets/study-statistics-bg.png) no-repeat 50%
  }

  .statistics-wrapper .statistics-box .statistics-body.exercise li {
    margin-right: 30px
  }

  .statistics-wrapper .statistics-box .statistics-body.exercise li .statistics-item-name {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .statistics-wrapper .statistics-box .statistics-body.exercise li .statistics-item-name .name-icon {
    width: 64px;
    height: 64px;
    margin-right: 10px
  }

  .statistics-wrapper .statistics-box .statistics-body.exercise li .statistics-item-name .name-text {
    font-size: 20px;
    color: #666
  }

  .statistics-wrapper .statistics-box .statistics-body li {
    width: 350px;
    border-radius: 6px;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, .1);
    margin-bottom: 20px;
    padding: 25px;
    display: flex;
    flex-direction: column;
    align-items: center
  }

  .statistics-wrapper .statistics-box .statistics-body li .statistics-item-content {
    flex: 1
  }

  .statistics-wrapper .statistics-box .statistics-body li .statistics-item-content .statistics-item-name {
    font-size: 20px;
    color: #666;
    text-align: center;
  }

  .statistics-wrapper .statistics-box .statistics-body li .statistics-item-content .statistics-item-progress {
    margin-top: 10px;
    color: #666;
    font-size: 20px;
    text-align: center
  }

  .statistics-wrapper .statistics-box .statistics-body li .statistics-item-content .statistics-item-progress .progress-item {
    width: 146px;
    display: inline-block
  }

  .statistics-wrapper .statistics-box .statistics-body li .statistics-item-content .statistics-item-progress .progress-item+.progress-item {
    border-left: 1px solid #c4c4c4
  }

  .statistics-wrapper .statistics-box .statistics-body li .statistics-item-content .statistics-item-progress .progress-item p:first-child {
    font-size: 16px
  }

  .statistics-wrapper .statistics-box .statistics-body li .statistics-item-content .statistics-item-progress .progress-item p:first-child span {
    font-size: 30px;
    color: #333
  }

  .statistics-wrapper .statistics-box .statistics-body li .statistics-item-content .statistics-item-circle {
    width: 100%;
    padding: 40px 0 0 0;
    text-align: center
  }

  .statistics-wrapper .statistics-box .statistics-body li .statistics-item-content .statistics-item-circle span {
    font-size: 20px;
    color: #666
  }

  .prodet-bg {
    background: #2f3133 url(../assets/player-bg-p.png) repeat-y top;
    width: 100%;
    padding-top: 70px;
  }

  .prodet-bg .por-box-location {
    height: 70px;
    line-height: 70px;
    color: #999;
    font-size: 16px
  }

  .prodet-bg .por-box-location i {
    vertical-align: -.08em
  }

  .prodet-bg .por-box-location span {
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px
  }

  .prodet-bg .por-box-location span>span {
    height: 26px;
    line-height: 26px;
    padding: 0 12px;
    border-radius: 4px;
    vertical-align: .08em;
    color: #fff;
    background: linear-gradient(90deg, #27a3ff, #2380fb)
  }

  .prodet-bg .por-box-b {
    width: 100%;
    height: 50px;
    background: #1b1b1b
  }

  .prodet-bg .por-box-b .pro-selecat {
    color: #fff;
    float: right;
    height: 50px;
    display: flex;
    align-items: center
  }

  .prodet-bg .por-box-b .por-boxb-a {
    position: relative;
    width: 130px;
    height: 50px;
    font-size: 16px;
    text-align: center;
    float: left;
    border-right: 1px solid #272727;
    margin-left: -1px
  }

  .prodet-bg .por-box-b .por-boxb-a.selected,
  .prodet-bg .por-box-b .por-boxb-a:hover {
    color: #fff;
    background: linear-gradient(90deg, #27a3ff, #2380fb)
  }

  .prodet-bg .por-box-b .por-boxb-a .por-boxb-title {
    display: block;
    width: 100%;
    height: 50px;
    line-height: 50px;
    color: #fff;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 10px;
    cursor: pointer
  }

  .prodet-bg .por-box-b .por-boxb-a .por-boxb-expire {
    position: absolute;
    right: 0;
    top: -20px
  }

  .prodet-bg .por-box-b .por-boxb-b {
    float: right;
    text-align: center;
    position: relative;
    height: 60px;
    padding-right: 12px
  }

  .prodet-bg .por-box-b .por-boxb-b .por-boxb-title {
    margin-top: 12px;
    height: 36px;
    line-height: 34px;
    border: 1px solid #bbb;
    background-color: #4e4e4e;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    padding-right: 5px
  }

  .prodet-bg .por-box-b .por-boxb-b .por-boxb-title span {
    width: 100px;
    padding-left: 5px;
    display: inline-block;
    vertical-align: middle;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden
  }

  .prodet-bg .por-box-b .por-boxb-b .por-boxb-list {
    position: absolute;
    background-color: #1b1b1b;
    width: 325px;
    top: 60px;
    right: -325px;
    height: 500px;
    z-index: 100;
    overflow-y: auto;
    transition: all .2s ease-in-out
  }

  .prodet-bg .por-box-b .por-boxb-b .por-boxb-list li {
    height: 50px;
    line-height: 50px;
    width: 100%;
    padding: 0 20px
  }

  .prodet-bg .por-box-b .por-boxb-b .por-boxb-list li.selected,
  .prodet-bg .por-box-b .por-boxb-b .por-boxb-list li:hover {
    color: #fff;
    background: linear-gradient(90deg, #27a3ff, #2380fb)
  }

  .prodet-bg .por-box-b .por-boxb-b .por-boxb-list li>a {
    display: block;
    color: #fff;
    text-align: left;
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden
  }

  .prodet-bg .por-box-b .por-boxb-b:hover .por-boxb-title {
    border: 1px solid transparent;
    background: linear-gradient(90deg, #349eee, #6f98f9)
  }

  .prodet-bg .por-box-b .por-boxb-b:hover .por-boxb-list {
    right: 0
  }

  .prodet-bg .prodet-player {
    width: 100%;
    position: relative
  }

  .prodet-bg .prodet-player .prodet-player-lock {
    position: absolute;
    left: 0;
    right: 0;
    width: 1125px;
    height: 100%;
    background: rgba(0, 0, 0, .9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 500
  }

  .prodet-bg .prodet-player .prodet-player-lock .podet-player-lock-icon {
    font-size: 60px;
    color: #fff;
    text-align: center
  }

  .prodet-bg .prodet-player .prodet-player-lock .podet-player-lock-icon p {
    font-size: 20px
  }

  .prodet-bg .prodet-player .live-box-c {
    float: left;
    width: 1200px;
    height: 675px;
    background: #e4ebef
  }

  .video-js .vjs-big-play-button{
    left: 355px !important;
    top: 230px !important;
  }

  .prodet-bg .prodet-player .prodet-box-d {
    float: left;
    width: 400px;
    height: 500px;
    background: #1f2123
  }

  .prodet-bg .prodet-player .prodet-box-d .prodet-boxd-a {
    float: left;
    width: 336px;
    height: 500px;
    padding: 12px 0 11px 0
  }

  .prodet-bg .prodet-player .prodet-box-d .prodet-boxd-b {
    width: 64px;
    height: 500px;
    float: right;
    background: #000;
    position: relative
  }

  .prodet-bg .prodet-player .prodet-box-d .prodet-boxd-b .prodet-pt-a {
    position: relative;
    width: 64px;
    height: 64px;
    padding: 10px 0;
    text-align: center;
    color: #fff;
    margin-bottom: 2px;
    cursor: pointer
  }

  .prodet-bg .prodet-player .prodet-box-d .prodet-boxd-b .prodet-pt-a a {
    color: #fff
  }

  .prodet-bg .prodet-player .prodet-box-d .prodet-boxd-b .prodet-pt-a i {
    width: 26px;
    height: 26px;
    padding: 2px 0;
    font-size: 22px
  }

  .prodet-bg .prodet-player .prodet-box-d .prodet-boxd-b .prodet-pt-a p {
    font-weight: 700;
    font-size: 12px
  }

  .prodet-bg .prodet-player .prodet-box-d .prodet-boxd-b .prodet-pt-a.active,
  .prodet-bg .prodet-player .prodet-box-d .prodet-boxd-b .prodet-pt-a:hover {
    color: #fff;
    background: linear-gradient(90deg, #27a3ff, #2380fb)
  }

  .prodet-bg .prodet-player .prodet-box-d .prodet-boxd-b .prodet-pt-a.active:before {
    position: absolute;
    content: " ";
    border: 8px solid transparent;
    border-right: 8px solid #27a3ff;
    bottom: 25px;
    left: -16px
  }

  .prodet-bg .prodet-action {
    padding: 16px 0;
    height: 72px
  }

  .prodet-bg .prodet-action .prodet-box-e {
    width: 500px;
    height: 40px;
    line-height: 40px
  }

  .prodet-bg .prodet-action .prodet-box-e span {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    color: #fff
  }

  .prodet-bg .prodet-action .prodet-box-e span.active {
    color: #27a3ff
  }

  .prodet-bg .prodet-action .prodet-box-e span abbr {
    margin-left: 2px
  }

  .prodet-bg .prodet-action .prodet-box-e span i {
    vertical-align: -.1em;
    margin-right: 3px
  }

  .prodet-bg .prodet-action .prodet-box-f {
    width: 900px;
    height: 40px;
    float: right;
    text-align: right
  }

  .prodet-bg .prodet-action .prodet-box-f .product-buy-class {
    float: left;
    width: 480px;
    text-align: right;
    margin-right: 30px
  }

  .prodet-bg .prodet-action .prodet-box-f .product-buy-class span {
    width: 120px;
    height: 40px;
    border: 1px solid #fff;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
    margin-right: 15px;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    position: relative;
    z-index: 2;
    background-color: #2f3133
  }

  .prodet-bg .prodet-action .prodet-box-f .product-buy-class span.selected,
  .prodet-bg .prodet-action .prodet-box-f .product-buy-class span:not(.disabled):hover {
    border-color: #ff6a00;
    color: #ff6a00
  }

  .prodet-bg .prodet-action .prodet-box-f .product-buy-class .product-buy-class-tips {
    position: absolute;
    top: -25px;
    right: 15px;
    z-index: 1;
    color: #eb5025;
    font-size: 14px;
    text-align: center;
    width: 100px;
    height: 39px;
    display: block;
    background: url(data:image/png;base64,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) no-repeat
  }

  .prodet-bg .prodet-action .prodet-box-f .prodet-boxf-c {
    float: left;
    margin-right: 32px;
    color: #fd9801;
    font-size: 32px
  }

  .prodet-bg .prodet-action .prodet-box-f .prodet-boxf-b {
    font-size: 1.6rem;
    color: #fff;
    display: block;
    float: left;
    line-height: 40px;
    margin-right: 32px;
    text-decoration: line-through;
    margin-top: 10px
  }

  .product-info-bar {
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: url(../assets/product-detail-title.png) no-repeat 0;
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    text-indent: 1em
  }

  .product-info-bar-en {
    position: absolute;
    top: 30px;
    right: 12px
  }

  .product-detail {
    width: 800px;
    background: #fff;
    float: left;
    margin-top: 30px;
    margin-bottom: 30px;
    padding: 20px 30px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1)
  }

  .product-detail .product-info-bar {
    margin-left: -30px
  }

  .product-detail .product-info-title {
    padding: 30px 0 10px 0;
    font-size: 22px;
    color: #414141
  }

  .product-detail .product-info-sub {
    padding: 30px 0 10px 0;
    font-size: 18px;
    color: #666
  }

  .product-detail .product-info-body {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px dashed #ddd
  }

  .product-detail .product-info-body.col1 li {
    width: 100%
  }

  .product-detail .product-info-body li {
    width: 50%;
    color: #666;
    font-size: 16px;
    display: flex;
    margin: 5px 0
  }

  .product-detail .product-info-body li .info-item span {
    font-size: 22px;
    color: #999;
    line-height: 1;
    vertical-align: -.1em
  }

  .product-detail .product-info-body li .info-content {
    flex: 1
  }

  .product-detail .product-info-body li .info-content em {
    font-style: normal
  }

  .product-detail .product-info-body li .info-content span {
    display: inline-block;
    color: #999;
    margin-right: 10px
  }

  .product-detail .product-info-body li .info-content>span {
    min-width: 160px
  }

  .product-detail .product-course-list {
    border-bottom: 1px dashed #ddd
  }

  .product-detail .product-course-list dl dt {
    font-weight: 700;
    color: #666;
    font-size: 16px
  }

  .product-detail .product-course-list dl dd {
    display: inline-block;
    margin-right: 20px;
    margin-top: 5px;
    margin-bottom: 20px;
    color: #666;
    font-size: 16px
  }

  .product-detail .product-info-textbook {
    display: flex;
    font-size: 16px;
    border-bottom: 1px dashed #ddd;
    padding-bottom: 20px
  }

  .product-detail .product-info-textbook .textbook-img {
    width: 80px;
    height: 100px
  }

  .product-detail .product-info-textbook .textbook-info {
    color: #999
  }

  .product-detail .product-info-textbook .textbook-info .textbook-name {
    font-size: 20px;
    color: #666;
    margin-bottom: 6px
  }

  .product-detail .product-info-textbook .textbook-info span {
    font-size: 16px;
    line-height: 2;
    margin-left: 8px;
    margin-right: 50px
  }

  .product-detail .product-info-detail {
    margin-top: 30px;
    text-align: center;
    width: 100%
  }

  .product-detail .product-info-detail img {
    display: inline-block
  }

  .product-sider {
    width: 370px;
    float: right;
    background: #fff;
    margin-top: 30px;
    padding: 20px 10px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1)
  }

  .product-sider .product-info-bar {
    margin-left: -10px;
    margin-bottom: 30px
  }

  .sider-nav {
    position: fixed;
    left: 100px;
    top: 260px;
    width: 120px;
    background: #333;
    box-shadow: 0 0 5px rgba(0, 0, 0, .6);
    z-index: 200;
    transition: all .3s ease-in-out
  }

  .sider-nav.put-away {
    left: -128px
  }

  .sider-nav.put-away .pos {
    right: -38px;
    box-shadow: 0 0 3px rgba(0, 0, 0, .6)
  }

  .sider-nav .pos {
    position: absolute;
    width: 30px;
    height: 40px;
    line-height: 40px;
    transition: all .3s ease-in-out;
    background: #333;
    color: #fff;
    font-size: 22px;
    text-align: center;
    right: 120px;
    top: 50%;
    margin-top: -21px;
    cursor: pointer;
    box-shadow: -2px 0 3px rgba(0, 0, 0, .6)
  }

  .sider-nav .nav-item {
    position: relative;
    width: 100%;
    height: 60px;
    line-height: 60px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    font-size: 16px
  }

  .sider-nav .nav-item.selected,
  .sider-nav .nav-item:hover {
    color: #fff;
    background: linear-gradient(90deg, #27a3ff, #2380fb)
  }

  .sider-nav .nav-item.selected:after {
    position: absolute;
    content: " ";
    border: 8px solid transparent;
    border-left: 8px solid #2481fc;
    bottom: 23px;
    right: -16px
  }

  .video-catalog-wrap {
    height: 470px;
    width: 336px;
    position:relative;
  }
  .video-catalog-wrap .down-model{
    position: absolute;
    width:100%;
    height:100%;
    top:0;
    left:0;
    background: rgba(0,0,0,0.6);
    color: #fff;
    text-align: center;
    padding-top:170px;
  }
  .video-catalog-wrap .down-model p{
    margin-top:20px;
    font-size: 18px;
  }

  .video-catalog-wrap .video-catalog-list {
    width: 336px;
    padding-bottom: 20px
  }

  .video-catalog-wrap .video-catalog-list li {
    margin: 7px 0;
    line-height: 40px;
    display: block;
    position: relative;
  }

  .video-catalog-wrap .video-catalog-list li p {
    color: #ccc;
    display: flex;
    align-items: center;
    line-height: 40px;
    padding: 0 10px;
    font-size: 16px;
    overflow: hidden
  }

  .video-catalog-wrap .video-catalog-list li p a {
    flex: 1;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden
  }

  .video-catalog-wrap .video-catalog-list li p a>i {
    color: #ccc;
    margin-right: 6px;
    font-size: 18px
  }

  .video-catalog-wrap .video-catalog-list li p a:first-child {
    color: #fff;
    font-size: 16px
  }

  .video-catalog-wrap .video-catalog-list li p a.lecture-view {
    flex: 0 1 36px
  }

  .video-catalog-wrap .video-catalog-list li p .play-finish {
    flex: 0 0 12px;
    width: 12px;
    height: 12px;
    line-height: 1;
    background-color: #ccc;
    border-radius: 10px
  }

  .video-catalog-wrap .video-catalog-list li p .play-finish i {
    display: block;
    margin: -2px
  }

  .video-catalog-wrap .video-catalog-list li.selected,
  .video-catalog-wrap .video-catalog-list li p:hover {
    background-color: #393939
  }

  .video-catalog-wrap .video-catalog-list>li>ul>li>p {
    padding-left: 30px
  }

  .video-catalog-wrap .video-catalog-list>li>ul>li>p a:first-child {
    color: #ddd;
    font-size: 16px
  }

  .video-catalog-wrap .video-catalog-list>li>ul>li>ul>li>p {
    padding-left: 40px
  }

  .video-catalog-wrap .video-catalog-list>li>ul>li>ul>li p a>i {
    vertical-align: -.02em;
    color: #999
  }

  .video-catalog-wrap .video-catalog-list>li>ul>li>ul>li p a:first-child {
    color: #999;
    font-size: 14px
  }

  .video-catalog-wrap {
    height: 470px;
    width: 336px
  }

  .no-video-player {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1200px;
    height: 500px;
    margin: 0;
    background: #00101b;
    direction: ltr;
    text-align: center;
    position: relative;
    z-index: 2;
  }

  .no-video-player .no-video-error {
    text-align: center;
    display: inline-block;
    color: #fff;
    font-size: 14px;
    line-height: 1;
  }

  .no-video-player .no-video-error .no-video-errorIcon {
    display: inline-block;
    width: 280px;
    height: 200px;
  }

  .no-video-player .no-video-error .no-video-errorMessage {
    margin-top: 1px;
  }

  .course-down{
    position: absolute;
    font-size: 28px;
    background: rgba(0,0,0,0.6);
    width: 100%;
    text-align: center;
    top: 0;
    left: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    height:44px;
  }
  .course-down a{
    color:#fff;
  }
  .course-down .el-button{
    padding:2px 15px;
    height: 26px;
    margin: 7px 10px 0px 10px;
  }
  .downbtn .el-icon-download{
    font-size:20px;
  }

  .practice-nodata {
    padding: 35px;
    text-align: center;

    img {
      margin: 0 auto;
    }

    p {
      margin-top: 16px;
      text-align: center;
      font-size: 18px;
    }
  }

  .video-catalog-wrap .video-catalog-list li.vlist{
    padding-left:10px;
  }

  .video-catalog-wrap .video-catalog-list li.vlist1{
    padding-left:20px;
  }

  .video-catalog-wrap .video-catalog-list li.chapter{
    margin:2px 0px 2px 10px;
    color:#fff;
    font-size:15px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height:20px;
  }

  .video-catalog-wrap .video-catalog-list li.chapter1{
    margin:2px 0px 2px 20px;
  }
  .xin{
    position:absolute;
    top:0;
    right:10px;
    font-size: 15px;
    color: red;
    font-weight: bold;
  }
  .downtips{
    position: absolute;
    background: #fff;
    width: 250px;
    border-radius: 5px;
    padding: 5px;
    top: -63px;
    left: 50px;
  }
  .autoplay{
    float: right;
    color: #fff;
    width: 158px;
    margin-top: 21px;
  }
  .autoplay label{
    cursor: pointer;
  }
  .autoplay input{
    margin-right:5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/liveback.vue